<template>
    <div class="container bg-light content-space-2 d-flex justify-content-center align-items-center flex-column">
        <div 
            v-if="$validateText(slice.primary.text)"
            v-html="$prismic.asHtml(slice.primary.text)" 
            class="headers-in-primary text-center"
        />


        <div class="my-3 w-100 w-lg-50 d-flex justify-content-center align-items-center flex-column">

            <div class="w-100 d-flex justify-content-between small">
                <span>{{ getLowestLinkText() }}</span>
                <span>{{ getHighestLinkText() }}</span>
            </div>
            <div class="w-100">
                <input 
                class="form-range form-range-lg" 
                type="range" 
                v-model="sliderValue" 
                min="0" 
                :max="loanAmountPages.length - 1" 
                step="1" 
                placeholder="Amount"
                >
            </div>

            <div class="input-card rounded-3 mb-3 w-100 mt-2">
                <div class="form-floating flex-grow-1">
                    <span 
                        id="floatingInput" 
                        type="text" 
                        class="form-control pt-5" 
                        placeholder="John Doe"
                    >
                        {{ currentLinkText }}
                    </span>
                    <label 
                        class="text-start" 
                        for="floatingInput muted"
                    >
                        {{ this.$translate('loan_amount', 'Lånebelopp') }}
                    </label>
                </div>
                <button 
                    class="fw-bold btn btn-primary btn-sm rounded-3" 
                    @click.prevent="toComparison"
                >
                    {{ $translate('loan_amount_selector_cta_text', 'Till jämförelsen') }}
                </button>
            </div>
        </div>
        <span v-if="! showAllAmounts" role="button" class="text-center" @click="showAllAmounts = !showAllAmounts">
            {{ $translate('loan_amount_selector_show_all', 'Se alla lånebelopp') }} <i class="bi bi-arrow-down" />
        </span>
        <div v-show="showAllAmounts" class="flex-column w-100 w-lg-50 gap-1" :class="{'d-none': !showAllAmounts, 'd-flex': showAllAmounts}">
            <nuxt-link
                v-for="(loanAmountPage, index) in loanAmountPages" 
                :key="index" 
                :to="loanAmountPage.link_url"
                class="btn btn-white btn-sm text-dark fw-bold w-100 border-0 rounder-3 d-flex justify-content-between align-items-center"
            >
                {{ loanAmountPage.link_text }}
                <i class="bi bi-arrow-right"></i>
            </nuxt-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        },
        document: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sliderValue: 0,
            showAllAmounts: false,
        }
    },
    created() {
        const index = this.loanAmountPages
            .findIndex(iterator => iterator.document_id === this.document.id); 
        if (index !== -1) {
            this.sliderValue = index;
        }
    },
    computed: {
        loanAmountPages() {
            const min = this.slice.primary.min_amount ?? 0;
            const max = this.slice.primary.max_amount ?? 9999999999;

            const loanAmountPages = Object.values(this.$store.state.settings.loan_amount_pages)
                .sort((a, b) => a.amount - b.amount)
                .map(iterator => {
                    return {
                        amount: iterator.amount,
                        link_text: iterator.link_text,
                        document_id: iterator.page.id,
                        link_url: this.$prismic.linkResolver(iterator.page)
                    }
                })
                .filter(iterator => iterator.amount >= min && iterator.amount <= max);
            
            return loanAmountPages;
        },
        currentLinkText() {
            if (this.loanAmountPages.length === 0) {
                return '';
            }

            return this.loanAmountPages[this.sliderValue].link_text;
        }
    },
    methods: {
        getLowestLinkText() {

            if (this.loanAmountPages.length === 0) {
                return '';
            }

            return this.loanAmountPages[0].link_text;
        },
        getHighestLinkText() {

            if (this.loanAmountPages.length === 0) {
                return '';
            }
            return this.loanAmountPages[this.loanAmountPages.length - 1].link_text;
        },
        toComparison() {
            this.$router.push(
                this.loanAmountPages[this.sliderValue].link_url
            );
        }
    }
}
</script>